import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Input } from 'antd';
import { useDispatch } from 'react-redux';
import { updateLocal } from 'store/adminPanel/actions';

const EditModal = ({ isVisible, setVisible, local, country }) => {
    const dispatch = useDispatch();

    const [localName, setLocalName] = useState(local?.name);
    const [localString, setLocalString] = useState(local?.localString);
    const [edited, setEdited] = useState(false);

    // useEffect(() => {
    //     if(usersId){
    //         dispatch(getUserData(usersId));
    //     }
    // }, [usersId, edited]);

    useEffect(()=>{
      setLocalName(local?.name);
      setLocalString(local?.localString);
      setEdited(false);
    },[local, edited]);

    const handleOk = () => {
      dispatch(updateLocal(country, localName, localString));
      setEdited(true)
      setVisible(false);
    }

    return (
      <Modal
        isVisible={isVisible}
        Icon={Pencil}
        onCancel={() => setVisible(false)}
        onOk={()=> handleOk()}
        title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1rem"}}>Edit</h1>}
        width={817}
        okText="Edit User"
      >
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Name</span>
            <Input disabled style={{height:"40px"}} value={localName}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>LocalString</span>
            <Input style={{height:"40px"}} value={localString} onChange={event=>setLocalString(event.target.value)}></Input>
        </div>
      </Modal>
    );
  };
  
  export default EditModal;